import '../common/common.js';
import './addToBasket.js';
import { AddToBasketConfirmation } from './AddToBasketConfirmation.js';
import { AddToBasketPerformanceMarketing } from './AddToBasketPerformanceMarketing.js';
import { AppsApi } from './AppsApi.js';
import { Utils } from '../common-public/Utils.js';

new AddToBasketConfirmation(window.o_order.tracking, new AddToBasketPerformanceMarketing(), new Utils()).initialize();
new AppsApi().initialize();
window.o_global.eventQBus.emitModuleLoaded('ft1.order-core.add-to-basket');
